import { useTheme, useWindowDimensions } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

const SMALL_SCREEN_WIDTH = 800;

export const useStyles = () => {
  const { width } = useWindowDimensions();

  const { theme } = useTheme();

  const cardLargeWidth = width * 0.8 + spacing.l * 4;
  const cardSmallWidth = width * 0.8 + spacing.xs * 2;

  const styles: Record<string, CSSProperties> = {
    container: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    inner: {
      width: width >= SMALL_SCREEN_WIDTH ? cardLargeWidth : cardSmallWidth,
      backgroundColor: theme.card.background,
      padding: spacing.m,
      borderRadius: constants.radius.view,
    },
    title: {
      fontWeight: "bold",
    },
  };

  return styles;
};
